import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

import { compose, graphql } from "react-apollo";
import gql from "graphql-tag";

import TopBar from "./Ops.Merchants.MerchantsGeneralTopBar";
import { Grid } from "@material-ui/core";

class TagCloud extends React.Component<any, any> {
  render() {
    let tagCloud: JSX.Element;
    const availableTags = this.props.merchantTags.merchant_tags;
    if (availableTags) {
      const sum = availableTags.reduce(
        (total, current) => total + current.count,
        0
      );

      tagCloud = (
        <Grid container spacing={16} justify="center">
          {availableTags.map(tag => (
            <Grid item key={tag.name}>
              <RouterLink
                className="blueLink"
                style={{
                  fontSize: `${1 + 3 * (tag.count / sum)}em`
                }}
                to={`/snapscan/ops/merchants/list?tags=${tag.name}`}
              >
                {tag.name} ({tag.count})
              </RouterLink>
            </Grid>
          ))}
        </Grid>
      );
    } else {
      tagCloud = <div>Loading...</div>;
    }
    return (
      <div>
        <TopBar />
        <section className="padded">{tagCloud}</section>
      </div>
    );
  }
}

const tagsQuery = graphql(
  gql`
    query merchantTags {
      merchant_tags {
        name
        count
      }
    }
  `,
  {
    name: "merchantTags"
  }
);

export default compose<any>(tagsQuery)(TagCloud);
